<template>
    <div class="section-group">
        <div class="checkbox-options">
            <div class="checkbox-option">
                <input
                    type="checkbox"
                    :id="fieldName"
                    :name="fieldName"
                    :checked="checked"
                    :value="value"
                    :readonly="readonly"
                    @change="$emit('change', $event.target.checked)"
                />

                <label :for="fieldName">{{ title }}</label>
            </div>
        </div>
    </div>
</template>

<script>
// Example Usage:
// <dealer-agreement-form-field-checkbox fieldName="field" />

export default {
    name: 'dealer-agreement-form-field-checkbox',

    model: {
        prop: 'checked',
        event: 'change',
    },

    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },

        fieldName: {
            type: String,
            required: true,
        },

        checked: {
            type: Boolean,
            required: false,
            default: false,
        },

        value: {
            type: Boolean,
            required: false,
        },

        readonly: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
